export * from './badge.component';
export * from './interface';
